import request from '@/utils/request';

export function UpdateAPI() {
    return {
        // 获取cos临时密钥
        getCos: params => {
            return request({
                url: '/admin/upload/get_cos_temporary_key',
                method: 'get',
                params,
            });
        },
        getUpload: params => {
            return request({
                url: '/admin/novel/chapter/upload_novel_chapter',
                method: 'post',
                params,
            });
        },
        //同步剧集信息到抖音云
        getTiktok: params => {
            return request({
                url: '/admin/novel/episodes/sync_movie_episodes_tiktok',
                method: 'post',
                params,
            });
        },
        //同步小说章节到微信小程序
        getWechat: params => {
            return request({
                url: '/admin/novel/wechat/sync_novel_chapter_wx',
                method: 'post',
                params,
            });
        },
    };
}
